var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 footer-bottom"},[_c('p',{staticClass:"mb-0"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Copyright AOarmor, LLC ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }